var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5657 1.56569C11.8781 1.25327 11.8781 0.746734 11.5657 0.434315C11.2533 0.121895 10.7467 0.121895 10.4343 0.434315L11.5657 1.56569ZM0.434315 10.4343C0.121895 10.7467 0.121895 11.2533 0.434315 11.5657C0.746734 11.8781 1.25327 11.8781 1.56569 11.5657L0.434315 10.4343ZM1.56569 0.434315C1.25327 0.121895 0.746734 0.121895 0.434315 0.434315C0.121895 0.746734 0.121895 1.25327 0.434315 1.56569L1.56569 0.434315ZM10.4343 11.5657C10.7467 11.8781 11.2533 11.8781 11.5657 11.5657C11.8781 11.2533 11.8781 10.7467 11.5657 10.4343L10.4343 11.5657ZM10.4343 0.434315L0.434315 10.4343L1.56569 11.5657L11.5657 1.56569L10.4343 0.434315ZM0.434315 1.56569L10.4343 11.5657L11.5657 10.4343L1.56569 0.434315L0.434315 1.56569Z",
    fill: "#0F143A",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.2acd209d2c6c8b79c387eba21f3e7be2.svg";
export { ForwardRef as ReactComponent };